import { EntityModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface ManageWorkspaceAdminContextType {
  open: (entityToLeave?: EntityModel | null) => void;
  close: () => void;
  isOpen: boolean;
}

export const ManageWorkspaceAdminDialogContext =
  createContext<ManageWorkspaceAdminContextType | null>(null);
